import React, { useContext } from "react";
import { Card, CardActions, CardContent, CardHeader, Divider, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import { format } from "date-fns";
import Chip from "@mui/material/Chip";

import { Link } from "react-router-dom";

import MoreVertIcon from '@mui/icons-material/MoreVert';
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import { useSnackbar } from "../shared/SnackbarProvider";
import { Repo } from "../Repo";

import { AppContext } from "../Store";

const AccidentCard: React.FC<any> = ({ accident }) => {

  const context = useContext(AppContext);
  const { userContext } = context;

  const snack = useSnackbar();
  const repo = new Repo();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const markReviewed = async () => {
    setAnchorEl(null);

    try {
      await repo.markAccidentReviewed(accident);
      snack("'Reviewed' status changed", "success");
    }
    catch (e) {
      snack("Error marking accident as reviewed.", "error");
    }

  };

  const markVisibleToParents = async () => {
    setAnchorEl(null);

    try {
      await repo.markAccidentVisibleToParents(accident);
      snack("'Visible to Parents' status changed", "success");
    }
    catch (e) {
      snack("Error marking accident as reviewed.", "error");
    }
  };



  return (
    <Card variant="outlined">
      <CardHeader
        action={
          userContext.isTeacher() && (userContext.isAdmin() || accident.editUrl) &&
          <IconButton aria-label="settings" onClick={handleClick} >
            <MoreVertIcon />
          </IconButton>
        }
        title={accident.category}
        subheader={format(new Date(accident.date), "yyyy-MMM-dd")}
      />
      {userContext.isTeacher() &&
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          {userContext.isAdmin() && <MenuItem onClick={markReviewed}>Reviewed</MenuItem>}
          {userContext.isAdmin() && <MenuItem onClick={markVisibleToParents}>Visible to Parents</MenuItem>}
          {/* Entries added in the portal have no Google Form response to edit */}
          {accident.editUrl && <MenuItem component={Link} to={accident.editUrl} target="_blank">
            Edit
          </MenuItem>}
        </Menu>
      }
      <CardContent>
        <Typography color="text.secondary"><b>Teacher</b>: {accident.teacherId}</Typography>
        <Typography color="text.secondary"><b>Details</b>: {accident.details}</Typography>
        <Typography color="text.secondary"><b>Location</b>: {accident.location}</Typography>
        <Typography color="text.secondary"><b>Follow-up steps</b>: {accident.followUpSteps}</Typography>
      </CardContent>
      {
        userContext.isTeacher() &&
        <CardActions>
          <Chip
            label="Reviewed"
            size="small"
            variant="outlined"
            color={accident.reviewed ? "primary" : "error"}
            icon={accident.reviewed ? <CheckCircleIcon /> : <CancelIcon />}
          />
          <Chip
            label="Visible to parents"
            size="small"
            variant="outlined"
            color={accident.visibleToParents ? "primary" : "error"}
            icon={accident.visibleToParents ? <CheckCircleIcon /> : <CancelIcon />}
          />
          <Divider orientation="vertical" flexItem />
        </CardActions>
      }
    </Card>
  );
};

export default AccidentCard;
